import React from 'react';
import {Navbar, Nav} from 'react-bootstrap';
import {Link} from "react-router-dom";
import './Home.css';


const BottomNavbar = () => {
    return ( 
    <div>
        <Navbar collapseOnSelect  expand="lg" className="color-nav" variant="light">
             <span className="justify-content-right">
             <Navbar.Toggle />
  <Navbar.Collapse className="justify-content-end">
                   <Nav className="justify-content-end">
                        <Nav.Link><Link to="/">Home</Link></Nav.Link>
                        <Nav.Link><Link to="/contact">Contact</Link></Nav.Link>
                        <Nav.Link><Link to="/mining">Mining</Link></Nav.Link>
                        <Nav.Link><Link to="/special">Special Vehicles Supply</Link></Nav.Link>
                        <Nav.Link><Link to="/branches">Branches</Link></Nav.Link>
                        <Nav.Link><Link to="/industriel">Industriel Vehicles Supply</Link></Nav.Link>
                        <Nav.Link><Link to="/railway">Railway Parts</Link></Nav.Link>
                        <Nav.Link><Link to="/awards">Awards</Link></Nav.Link>
                        <Nav.Link><Link to="/about">About</Link></Nav.Link>
                        <Nav.Link><span className="fontcolorz">       ©2021 BUK Truck Parts Ltd.</span><span className="fontcolor">     Web App Developer: Tambo</span></Nav.Link>
                  </Nav>
                  </Navbar.Collapse> 
          </span> 
       </Navbar>
    </div>
     );
}
 
export default BottomNavbar;